module.exports = __webpack_public_path__ + "static/media/exc_exa_ins.895eaf55.png";